// Словарь раздела НЕ регистрируется здесь: ресурсы собирает `lib/i18n.ts`
// обходом каталога `locales/`. Раньше файл импортировал `ru`- и `en`-JSON и
// звал `addResourceBundle` на оба — при 21 локали (Д11) это означало бы 21
// импорт в каждом из тринадцати таких модулей и локаль, добавленную в
// репозиторий, но забытую в половине из них.

import { useTranslation } from "react-i18next";

/** Namespace лендинга приглашения `/ref/:code`. */
export const INVITE_NS = "invite";

/** Единственная точка доступа к текстам лендинга. */
export function useInviteT() {
	return useTranslation(INVITE_NS).t;
}
